import { render } from "./SlideItem.vue?vue&type=template&id=b7046ade"
import script from "./SlideItem.vue?vue&type=script&lang=js"
export * from "./SlideItem.vue?vue&type=script&lang=js"

import "./SlideItem.vue?vue&type=style&index=0&id=b7046ade&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__